import FreshChat from "@utils/freshchat";
import { useChatStore } from "@stores/chatStore";

export function GlobalFreshChat() {
  const chatModule = useChatStore((s) => s.module);
  const cookiesAccepted = useChatStore((s) => s.cookiesAccepted);

  if (!chatModule || !cookiesAccepted) return null;

  return (
    <FreshChat
      key={`${chatModule.url}|${chatModule.token}`}
      conversationalModule={chatModule}
    />
  );
}
